// AD ASTRONAUT brand logo. Composable lockup: the astronaut icon and the
// "AD ASTRONAUT" wordmark are TWO separate assets sized independently, so the
// astronaut sits taller than the text without shrinking the text. Two knobs
// (below) tune the whole look forever with no re-export.
//   variant="wordmark" (default) → astronaut + wordmark lockup
//   variant="mark"                → astronaut icon only (tight spots)
// `height` (px) drives the astronaut (the tallest element = the lockup height);
// the wordmark auto-sizes to WORDMARK_RATIO of it and vertically centers.
// Pass `className` for FILTERS / LAYOUT only (e.g. "brightness-0 invert" for
// white-on-dark, "flex-shrink-0") — never for height (use the `height` prop).

import astronaut from '@/assets-src/Astronaut-6.svg';
import wordmark from '@/assets-src/Wordmark-6.svg';

// Astronaut-6.svg = 60×75 (0.8:1). Wordmark-6.svg = 229×43 (5.33:1).
const WORDMARK_RATIO = 0.573; // wordmark height ÷ astronaut height (= 43/75, native)
const GAP_RATIO = 0.14;       // gap between icon + wordmark, ÷ astronaut height

export function Logo({
  variant = 'wordmark',
  height = 56,
  className = '',
  alt = 'AD Astronaut',
}: {
  variant?: 'wordmark' | 'mark';
  height?: number;
  className?: string;
  alt?: string;
}) {
  if (variant === 'mark') {
    return (
      <img
        src={astronaut}
        alt={alt}
        draggable={false}
        style={{ height }}
        className={`w-auto select-none ${className}`}
      />
    );
  }
  return (
    <span
      className={`inline-flex items-center ${className}`}
      style={{ gap: height * GAP_RATIO }}
    >
      <img
        src={astronaut}
        alt=""
        draggable={false}
        style={{ height }}
        className="w-auto select-none"
      />
      <img
        src={wordmark}
        alt={alt}
        draggable={false}
        style={{ height: height * WORDMARK_RATIO }}
        className="w-auto select-none"
      />
    </span>
  );
}
